<template>
  <div class="ac-body-container">
    <div class="ac-content-container flex-row just-between">
      <div class="flex-column just-between">
        <div>
          <div class="header">Filter Purchase Options</div>
          <div class="sub-header">When member wants to buy filters:</div>
          <SACRadio
            name="handle-filter"
            field="handler"
            value="smac"
            :checked="handler === 'smac'"
            :change="handleChange"
            label="allow purchases through SmartAC.com app (recommended)"
            :disable="adminRole !== 'admin'"
          />
          <SACRadio
            name="contact-method"
            field="method"
            value="website"
            :checked="method === 'website'"
            :change="onChange"
            label="direct them to contact my company via website"
            :disable="adminRole !== 'admin'"
            :error="errorObj.methodErr"
          />
          <div v-if="method === 'website'" class="body">Website Link</div>
          <SACInput
            v-if="method === 'website'"
            field="website"
            placeholder="http://website.com/filters"
            :value="website"
            :change="onChange"
            :error="errorObj.websiteErr"
            :disable="adminRole !== 'admin'"
          />
          <SACRadio
            name="contact-method"
            field="method"
            value="phone"
            :checked="method === 'phone'"
            :change="onChange"
            label="direct them to contact my company via phone call"
            :disable="adminRole !== 'admin'"
            :error="errorObj.methodErr"
          />
          <div v-if="method === 'phone'" class="body">Phone Number</div>
          <SACInput
            v-if="method === 'phone'"
            field="phone"
            placeholder="123-456-7890"
            :value="phone"
            :change="onChange"
            :error="errorObj.phoneErr"
            :disable="adminRole !== 'admin'"
          />
        </div>

        <div
          class="mt-6 sac__font-16 n70 med h-100"
          v-if="handler === 'smac' && strictFilterVendor"
        >
          <p>
            Restrict to {{ strictFilterVendor }}; don't allow filter purchased by homeowners if
            ConCom does not carry the particular size.
          </p>
        </div>
        <div
          class="mt-6 sac__font-16 n70 med h-100"
          v-else-if="handler === 'smac' && preferredFilterVendor"
        >
          <p>
            Prefer {{ preferredFilterVendor }}, fulfill using ConCom, even if SmartAC.com can
            provide a filter at a lower price.
          </p>
        </div>
        <div class="mt-6 sac__font-16 n70 med h-100" v-else-if="handler === 'smac'">
          <p>
            If you have a relationship with a filter vendor, contact your Partner Success Manager (PSM) to discuss options
          </p>
        </div>
      </div>
      <div v-if="handler === 'smac'" class="flex-row">
        <div class="d-flex flex-column just-center align-center">
          <div class="fp-preview-background">
            <img
              src="@shared/assets/img/partner-detail/filter-select.png"
              alt="temperature-preview"
              class="fp-home-img"
            />
          </div>
          <span class="fp-preview-title">Filter Selection</span>
          <span class="fp-preview-subtitle">Member App</span>
        </div>
        <div class="d-flex flex-column just-center align-center">
          <div class="fp-preview-background">
            <img
              src="@shared/assets/img/partner-detail/filter-cart.png"
              alt="temperature-preview"
              class="fp-home-img"
            />
          </div>
          <span class="fp-preview-title">Shopping Cart</span>
          <span class="fp-preview-subtitle">Member App</span>
        </div>
      </div>
      <div
        v-else-if="method === 'website' || method === 'phone'"
        class="d-flex flex-column just-center align-center pc-preview-container"
      >
        <div class="pc-preview-background">
          <img
            src="@shared/assets/img/partner-detail/phone-empty.png"
            class="pc-phone-img"
            alt="Phone Image"
          />
          <div class="pc-absolute-overlay">
            <div class="pc-popup-background-container">
              <div class="pc-preview-img" :style="backgroundStyles" />
              <div v-if="logoPreview" class="pc-logo-container">
                <img :src="logoPreview" class="pc-logo-img" alt="Partner Logo" />
              </div>
              <div class="pc-circle-container">
                <div class="pc-circle">
                  <img
                    src="@shared/assets/img/partner-detail/filter-stack.png"
                    class="pc-circle-img"
                    alt="Filters"
                  />
                </div>
              </div>
              <div class="pc-schedule-preview-info-container">
                <div class="sac__font-14 medium">Buy Filters</div>
                <div class="sac__font-10 ml-5 mr-5">
                  Need to purchase filters? You can purchase your filters at:
                </div>
                <div class="pc-preview-info-title mt-4">
                  {{ companyName }}
                </div>
                <div class="pc-preview-info">
                  {{ method === 'phone' ? phone : website }}
                </div>
              </div>
              <div class="pc-action">
                <div class="sac__font-14 medium button">
                  {{ method === 'phone' ? 'Call now' : 'Go to website' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <span class="fp-preview-title">Direct to Website</span>
        <span class="fp-preview-subtitle">Member App</span>
      </div>
    </div>
    <div v-if="handler === 'smac'" class="ac-content-container">
      <div class="header">Offered Filter Sizes</div>
      <div class="sub-header">Members choose from these options in-app</div>
      <div class="ac-checkbox-wrapper">
        <div class="ac-checkbox-header">MERV 8: Standard | Allergies</div>
        <SizeCheckRow
          field="merv8"
          :options="exceptionOptions.merv8"
          :onChange="handleExceptionToggle"
          :disabled="adminRole !== 'admin'"
        />
      </div>
      <div class="ac-checkbox-wrapper">
        <div class="ac-checkbox-header">MERV 11: Plus | Allergies, Pet Dander</div>
        <SizeCheckRow
          field="merv11"
          :options="exceptionOptions.merv11"
          :onChange="handleExceptionToggle"
          :disabled="adminRole !== 'admin'"
        />
      </div>
      <div class="ac-checkbox-wrapper">
        <div class="ac-checkbox-header">
          MERV 13: Premium | Allergies, Pet Dander, Virus Carriers
        </div>
        <SizeCheckRow
          field="merv13"
          :options="exceptionOptions.merv13"
          :onChange="handleExceptionToggle"
          :disabled="adminRole !== 'admin'"
        />
      </div>
      <div v-if="errorObj.mervErr" class="error-text">
        {{ errorObj.mervErr }}
      </div>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import SACInput from '@shared/components/sac/SACInput.vue';
import SACRadio from '@shared/components/sac/SACRadio.vue';
import SizeCheckRow from './filter/SizeCheckRow.vue';

export default {
  name: 'FilterPurchase',
  components: {
    SACInput,
    SACRadio,
    SizeCheckRow,
  },
  mixins: [partnerSettingsMixin],
  props: {
    handler: String,
    concomPartnerCode: String,
    strictFilterVendor: String,
    preferredFilterVendor: String,
    method: String,
    phone: String,
    website: String,
    companyName: String,
    logoPreview: String,
    primaryColor: String,
    exception: [String, Object],
    onChange: Function,
    errorObj: Object,
  },
  data() {
    const { exception } = this;
    let exceptionOptions = {
      merv8: {
        oneInch: true,
        twoInch: true,
        threeInch: true,
        fourInch: true,
        fiveInch: true,
        sixInch: true,
      },
      merv11: {
        oneInch: true,
        twoInch: true,
        threeInch: true,
        fourInch: true,
        fiveInch: true,
        sixInch: true,
      },
      merv13: {
        oneInch: true,
        twoInch: true,
        threeInch: true,
        fourInch: true,
        fiveInch: true,
        sixInch: true,
      },
    };
    if (exception) {
      if (typeof exception === 'string') {
        exceptionOptions = JSON.parse(exception);
      } else {
        exceptionOptions = exception;
      }
    }
    return {
      exceptionOptions,
    };
  },
  computed: {
    backgroundStyles() {
      return {
        'background-color': this.primaryColor,
        display: 'flex',
        'justify-content': 'flex-end',
      };
    },
  },
  watch: {
    exception(newException) {
      if (newException) {
        let exceptionOptions = {
          merv8: {
            oneInch: true,
            twoInch: true,
            threeInch: true,
            fourInch: true,
            fiveInch: true,
            sixInch: true,
          },
          merv11: {
            oneInch: true,
            twoInch: true,
            threeInch: true,
            fourInch: true,
            fiveInch: true,
            sixInch: true,
          },
          merv13: {
            oneInch: true,
            twoInch: true,
            threeInch: true,
            fourInch: true,
            fiveInch: true,
            sixInch: true,
          },
        };
        if (typeof newException === 'string') {
          exceptionOptions = JSON.parse(newException);
        } else {
          exceptionOptions = newException;
        }
        this.exceptionOptions = exceptionOptions;
      }
    },
  },
  methods: {
    handleExceptionToggle(key, field, value) {
      const newExceptionOptions = {
        ...this.exceptionOptions,
      };
      if (field) {
        newExceptionOptions[key] = {
          ...newExceptionOptions[key],
          [field]: value,
        };
      } else {
        Object.keys(newExceptionOptions[key]).forEach((k) => {
          newExceptionOptions[key][k] = value;
        });
      }
      this.exceptionOptions = newExceptionOptions;
      this.onChange('exception', newExceptionOptions);
    },
    handleChange(field, value) {
      this.onChange('exception', this.exceptionOptions);
      this.onChange(field, value);
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  font-size: 20px;
  font-weight: 600;
}
.sub-header {
  font-size: 16px;
  font-weight: 400;
  color: $N60;
}
.ac-content-container {
  padding: 15px 20px;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 1px solid #c4c5cc;
}
.ac-input-container,
.sac-radio-container {
  margin-top: 12px;
  margin-bottom: 0 !important;
}
.body {
  font-size: 0.875rem;
  margin-top: 8px;
  margin-bottom: 8px;
  color: $N80;
}
.sub-label {
  font-size: 1rem;
  font-weight: 500;
  color: $N60;
  max-width: 600px;
}
.ac-checkbox-wrapper {
  margin-top: 20px;
  .ac-checkbox-header {
    font-size: 1rem;
    font-weight: 700;
    text-decoration: underline;
    margin-bottom: 16px;
  }
}

.error-text {
  font-size: 0.875rem;
  font-weight: 500;
  color: $TOMATO100;
  padding-top: 12px;
}
.fp-home-img {
  height: 520px;
}
.fp-noc-img {
  width: 380px;
  border-radius: 8px;
}
.fp-preview-background {
  border-radius: 50px;
}
.fp-preview-title {
  margin-top: 10px;
  font-size: 18px;
  text-align: center;
}
.fp-preview-subtitle {
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  color: $N60;
}
.pc-preview-container {
  margin-left: 12px;
  margin-top: 15px;

  .pc-preview-background {
    position: relative;
    border-radius: 50px;
    background-color: $N100;
    height: 91%;
  }

  .pc-phone-img {
    height: 520px;
  }

  .pc-absolute-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pc-popup-background-container {
    width: 210px;
    height: 380px;
    border-radius: 4px;
    background-color: white;
    display: flex;
    justify-content: flex-end;

    .pc-preview-img {
      background-color: white;
      height: 130px;
      width: 210px;
    }
  }

  .pc-schedule-preview-info-container {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 180px;
    text-align: center;
  }

  .pc-action {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 85px;
    text-align: center;
    display: flex;
    justify-content: center;
    .button {
      background-color: #dce3ff;
      border-radius: 6px;
      padding: 8px 10px;
      width: 180px;
    }
  }

  .pc-preview-info-title {
    font-weight: 500;
    text-decoration: underline;
    font-size: 0.75rem;
    padding: 0 24px;
  }

  .pc-preview-info {
    font-size: 0.625rem;
  }

  .pc-logo-container {
    position: absolute;
    margin-top: 15px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .pc-logo-img {
      width: 85px;
      height: 85px;
      object-fit: contain;
    }
  }
  .pc-circle-container {
    position: absolute;
    margin-top: 105px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .pc-circle {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background-color: #dce3ff;
      width: 53px;
      height: 53px;
      .pc-circle-img {
        width: 40px;
        height: 40px;
        object-fit: contain;
      }
    }
  }

  .pc-preview-title {
    margin-top: 14px;
    text-align: center;
  }
}
</style>
